import { queryClient } from 'stateManagement/queries/client';

import {
  CURRENT_INVESTIGATION_NAME_STORAGE_KEY,
  CURRENT_INVESTIGATION_STORAGE_KEY,
} from 'blockscope/components/investigations/InvestigationStore';

export const updateRecentQueryCache = async (
  queryType,
  queryData,
  user,
  updateAll = true
) => {
  const investigationId = localStorage.getItem(
    CURRENT_INVESTIGATION_STORAGE_KEY
  );
  const investigationName = localStorage.getItem(
    CURRENT_INVESTIGATION_NAME_STORAGE_KEY
  );
  if (updateAll) {
    await queryClient.cancelQueries(['org', 'recent-queries', 'all']);
    const allQueries = queryClient.getQueryData([
      'org',
      'recent-queries',
      'all',
    ]);
    if (allQueries) {
      queryClient.setQueryData(
        ['org', 'recent-queries', 'all'],
        [
          {
            ...queryData,
            createdAt: new Date(),
            userId: user,
            __t: queryType,
            investigation: investigationId
              ? { _id: investigationId, name: investigationName }
              : undefined,
          },
          ...allQueries,
        ]
      );
    }
  }

  await queryClient.cancelQueries(['org', 'recent-queries', queryType]);
  const searchQueries = queryClient.getQueryData([
    'org',
    'recent-queries',
    queryType,
  ]);
  if (searchQueries) {
    queryClient.setQueryData(
      ['org', 'recent-queries', queryType],
      [
        {
          ...queryData,
          createdAt: new Date(),
          userId: user,
          __t: queryType,
          investigation: investigationId
            ? { _id: investigationId, name: investigationName }
            : undefined,
        },
        ...searchQueries,
      ]
    );
  }
};
